<template>
  <div class="batchCheck">
    <el-dialog
      title="批量审核"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
      class="checkDialog"
      :lock-scroll="false"
      :show-close="false"
      top="15vh"
    >
      <div class="main">
        <div class="form">
          <div class="text">已选择的{{ selectList.length }}名人员资料初审是否通过？</div>
          <div class="radioGroup">
            <el-radio-group v-model="radio" @change="handleChangeRadioFn">
              <el-radio :label="2">通过</el-radio>
              <el-radio :label="1">驳回</el-radio>
            </el-radio-group>
          </div>
          <div v-if="radio == 2">
            <div class="inputCss">
              <el-input
                v-model.trim="money"
                placeholder="金额"
                @keyup.native="money = inputChange(money)"
              ></el-input>
            </div>
            <div class="timePut">
              <el-date-picker
                v-model="applicationTime"
                type="datetime"
                placeholder="报考时间"
                style="width: 100%;"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </div>
          </div>
          <div v-if="radio == 1">
            <div class="text">
              <el-input
                v-model="remark"
                type="textarea"
                :rows="4"
                maxlength="500"
                show-word-limit
              ></el-input>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClearDataFn">取消</el-button>
        <el-button type="primary" @click="handleSubmitFn">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import to from 'await-to'
import { batchCheck } from '@/api/apply'
export default {
  data() {
    return {
      dialogVisible: false,
      radio: 2,
      money: '',
      applicationTime: '',
      remark: '',
      selectList: [],
    }
  },
  methods: {
    show(data) {
      this.selectList = data
      this.dialogVisible = true
    },
    async handleSubmitFn() {
      let arr = []
      if (this.selectList.length) this.selectList.map(v => arr.push(v.id))
      const [, err] = await to(
        batchCheck({
          idList: arr,
          status: this.radio,
          applicationTime: this.applicationTime,
          money: this.money,
          remark: this.remark,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      this.handleClearDataFn()
      this.$message.success('审批成功')
      this.$emit('success')
    },
    handleChangeRadioFn(e) {
      if (e == 1) {
        this.applicationTime = ''
        this.money = ''
      } else if (e == 2) {
        this.remark = ''
      }
    },
    async handleClearDataFn() {
      this.applicationTime = ''
      this.money = ''
      this.remark = ''
      this.selectList = []
      this.dialogVisible = false
    },
    //效验输入框
    inputChange(num) {
      let str = num.toString()
      var len1 = str.substr(0, 1)
      var len2 = str.substr(1, 1)
      //如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != '.') {
        str = str.substr(1, 1)
      }
      if (len1 == '.') {
        str = ''
      }
      //限制只能输入一个小数点
      if (str.indexOf('.') != -1) {
        var str_ = str.substr(str.indexOf('.') + 1)
        if (str_.indexOf('.') != -1) {
          str = str.substr(0, str.indexOf('.') + str_.indexOf('.') + 1)
        }
        if (str_.length > 2) {
          this.$message.warning(`金额小数点后只能输入两位，请正确输入！`)
          return (str = '')
        }
      }
      //正则替换
      str = str.replace(/[^\d.]/g, '') // 保留数字和小数点
      return str
    },
  },
}
</script>
<style lang="scss" scoped>
.checkDialog {
  .main {
    display: flex;
    justify-content: center;
    .radioGroup {
      margin-top: 20px;
    }
    ::v-deep .el-input {
      margin-top: 20px;
      width: 250px;
    }
    ::v-deep .el-date-editor {
      margin-top: 20px;
      width: 250px !important;
    }
    ::v-deep .el-textarea {
      margin-top: 20px;
      width: 250px !important;
    }
  }
}
</style>
